<template>
  <BaseCardV2
    :erreur="erreur"
    :has-btn-action="false"
    class="pa-2"
    has-help
    titre="Répartition des ventes"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <div class="ml-3 my-2 texte texte-gris-fonce">
        Mon exploitation
      </div>
      <BaseLoader v-if="loading" />
      <div
        v-else-if="hasDonneeAdherent"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'mr-1'"
        class="d-flex justify-space-around mt-4"
      >
        <BaseDoughnutChartV2
          :chart-data="chartDataAdherent"
          class="align-self-center "
        />

        <div class="align-self-center">
          <div
            v-if="hasDonneeAdherentPrixFerme"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsNumtiers[0]"
              class="chip mr-2"
              label
            >
              <span
                class="white--text"
                :class="repartitionTypeContrat.partPoidsPrixFermeEnPourcentage === 100 ? 'margin-5' :''"
              >{{ repartitionTypeContrat.partPoidsPrixFermeEnPourcentage | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Prix ferme</span>
          </div>
          <div
            v-if="hasDonneeAdherentGestionDeleguee"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsNumtiers[1]"
              class="chip mr-2"
              label
            >
              <span
                class="white--text"
                :class="repartitionTypeContrat.partPoidsGestionDelegueeEnPourcentage === 100 ? 'margin-5' :''"
              >{{ repartitionTypeContrat.partPoidsGestionDelegueeEnPourcentage | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Gestion déléguée</span>
          </div>
          <div
            v-if="hasDonneeAdherentAutres"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsNumtiers[2]"
              class="chip mr-2"
              label
            >
              <span
                class="white--text"
                :class="repartitionTypeContrat.partPoidsAutreEnPourcentage === 100 ? 'margin-5' :''"
              >{{ repartitionTypeContrat.partPoidsAutreEnPourcentage | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Autres</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
          class="d-flex align-center flex-column"
        >
          <img
            alt="no-contrats"
            src="@/assets/no-contrats.svg"
          >
          <div
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
            class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2"
          >
            <span>Vous n'avez pas de contrat</span>
          </div>
        </div>
      </div>
      <div
        v-if="hasDonneeGroupe && hasRegionSelected"
        class="ml-3 mt-8 my-2 texte texte-gris-fonce"
      >
        Mon groupe ({{ repartitionTypeContratGroupe.nbAdherents }} adhérent{{ repartitionTypeContratGroupe.nbAdherents > 1 ? 's' : '' }})
      </div>
      <div
        v-if="(!hasDonneeGroupe && !loading && hasDonneeAdherent) || !hasRegionSelected"
        class="ml-3 mt-8 my-2 texte texte-gris-fonce"
      >
        <BaseMessageV2 message="Nombre d'adhérents insuffisant pour la comparaison (&lt; 1 adhérent)" />
      </div>
      <div
        v-if="!loading && hasDonneeGroupe && hasRegionSelected"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'mr-1'"
        class="d-flex justify-space-around mt-4"
      >
        <BaseDoughnutChartV2
          :chart-data="chartDataGroupe"
          class="align-self-center "
        />

        <div class="align-self-center">
          <div
            v-if="hasDonneeGroupePrixFerme"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsGroupe[0]"
              class="chip mr-2"
              label
            >
              <span
                class="white--text"
                :class="repartitionTypeContratGroupe.partPoidsPrixFermeEnPourcentage === 100 ? 'margin-5' :''"
              >{{ repartitionTypeContratGroupe.partPoidsPrixFermeEnPourcentage | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Prix ferme</span>
          </div>
          <div
            v-if="hasDonneeGroupeGestionDeleguee"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsGroupe[1]"
              class="chip mr-2"
              label
            >
              <span
                class="secondary--text"
                :class="repartitionTypeContratGroupe.partPoidsGestionDelegueeEnPourcentage === 100 ? 'margin-5' :''"
              >{{ repartitionTypeContratGroupe.partPoidsGestionDelegueeEnPourcentage | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Gestion déléguée</span>
          </div>
          <div
            v-if="hasDonneeGroupeAutres"
            class="pt-2 texte texte-gris-fonce"
          >
            <v-chip
              :color="colorsGroupe[2]"
              class="chip mr-2"
              label
            >
              <span
                class="secondary--text"
                :class="repartitionTypeContratGroupe.partPoidsAutreEnPourcentage === 100 ? 'margin-5' :''"
              >{{ repartitionTypeContratGroupe.partPoidsAutreEnPourcentage | roundNumber(0) }} % </span>
            </v-chip>
            <span class="texte texte-gris-fonce">Autres</span>
          </div>
        </div>
      </div>

      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition des ventes"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-8">
            <p>Certains contrats ont été regroupés pour plus de lisibilité. Voici ce que chaque intitulé contient :</p>
            <li class="pb-2">
              <span class="black--text">Prix ferme :</span> Prix ferme avec option et prix ferme sans option (dont terme moisson et prix de marché). 
            </li>
            <li class="pb-2">
              <span class="black--text">Gestion déléguée :</span> Prix de campagne, prix par période (septembre-avril, novembre-mai et quinto), tous les contrats en gestion déléguée.
            </li>
            <li><span class="black--text">Autres :</span> Autoconso, contrats échanges, contrats filière, ventes sur pied.</li>
          </div>
        </div>
      </HelpModal>
    </div>
  </BaseCardV2>
</template>

<script>
import { mapGetters } from 'vuex'
import numberFilter from '@/filters/number.filter'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseDoughnutChartV2 from '@/components/chart/base-doughnut-chart-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageV2 from '@/components/common/base-message-v2.vue'
import HelpModal from '@/components/modal/help-modal.vue'

export default {
  name: 'RepartitionTypeContrat',
  components: {BaseCardV2, BaseDoughnutChartV2, BaseLoader, BaseMessageV2, HelpModal },
  props: {
    loading: {
      type: Boolean,
      default: null
    },
    erreur: {
      type: Boolean,
      default: null
    },
    hasRegionSelected: {
      type: Boolean,
      default: null
    },
  },
  data () {
    return {
      isOpenModalHelp: false,
      colorsNumtiers: ['#027F5F', '#74B335', '#A5C923'],
      colorsGroupe :['#64AB3B', '#B5D11D', '#E6E70B']
    }
  },

  computed: {
    ...mapGetters({
      repartitionTypeContrat: 'contratVente/repartitionTypeContrat',
      repartitionTypeContratGroupe:'contratVente/repartitionTypeContratGroupe',
      filtresAdherent: 'filtresComparaison/filtresAdherent'
    }),
    valuesAdherent () {
      return [
        this.repartitionTypeContrat.partPoidsPrixFermeEnPourcentage,
        this.repartitionTypeContrat.partPoidsGestionDelegueeEnPourcentage,
        this.repartitionTypeContrat.partPoidsAutreEnPourcentage,
      ]
    },
    valuesGroupe () {
      return [
        this.repartitionTypeContratGroupe.partPoidsPrixFermeEnPourcentage,
        this.repartitionTypeContratGroupe.partPoidsGestionDelegueeEnPourcentage,
        this.repartitionTypeContratGroupe.partPoidsAutreEnPourcentage,
      ]
    },
    chartDataAdherent () {
      return {
        id: 'chartDataAdherent',
        labels: ['Prix ferme', 'Gestion déléguée', 'Autres'],
        datasets: [
          {
            legendTooltip: {
              title: 'ventes',
              value: this.valuesAdherent.map(r => numberFilter.formatNumber(r, 2)),
              unit: '%'
            },
            backgroundColor: this.colorsNumtiers,
            data: this.valuesAdherent
          }
        ]
      }
    },
    chartDataGroupe () {
      return {
        id: 'chartDataGroupe',
        labels: ['Prix ferme', 'Gestion déléguée', 'Autres'],
        datasets: [
          {
            legendTooltip: {
              title: 'ventes',
              value: this.valuesGroupe.map(r=> numberFilter.formatNumber(r, 2)),
              unit: '%'
            },
            backgroundColor: this.colorsGroupe,
            data: this.valuesGroupe
          }
        ]
      }
    },
    hasDonneeAdherentPrixFerme () {
      return !!this.repartitionTypeContrat?.partPoidsPrixFermeEnPourcentage
    },
    hasDonneeAdherentGestionDeleguee () {
      return !!this.repartitionTypeContrat?.partPoidsGestionDelegueeEnPourcentage
    },
    hasDonneeAdherentAutres () {
      return !!this.repartitionTypeContrat?.partPoidsAutreEnPourcentage
    },
    hasDonneeAdherent () {
      return this.hasDonneeAdherentPrixFerme || this.hasDonneeAdherentGestionDeleguee || this.hasDonneeAdherentAutres
    },
    hasDonneeGroupePrixFerme () {
      return !!this.repartitionTypeContratGroupe?.partPoidsPrixFermeEnPourcentage
    },
    hasDonneeGroupeGestionDeleguee () {
      return !!this.repartitionTypeContratGroupe?.partPoidsGestionDelegueeEnPourcentage
    },
    hasDonneeGroupeAutres () {
      return !!this.repartitionTypeContratGroupe?.partPoidsAutreEnPourcentage
    },
    hasDonneeGroupe () {
      return this.repartitionTypeContratGroupe.nbAdherents > 0 &&
        (this.hasDonneeGroupePrixFerme || this.hasDonneeGroupeGestionDeleguee || this.hasDonneeGroupeAutres)
    }
  }
}

</script>

<style lang="scss" scoped>
.chip {
  width: 55px;
}
.margin-5 {
  margin-left: -5px;
}
</style>
